import { saveMegaMenu } from "../../features/MegaMenu/MegaMenuSlice";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { CATALOGUE_LISTING } from "./cataloguePage.gql";

export const useCataloguePage = (route) => {
  const [selectedCatalogue, setSelectedCatalogue] = useState("");
  const [getListing, { data, loading, error }] = useLazyQuery(
    CATALOGUE_LISTING,
    {
      variables: { type: route === "catalogue" ? "0" : "1" },
    }
  );

  const forceDownload = (url) => {
    const filename = "document.pdf";
    // const filename = url.split("/").pop();
    // if ((authData.isSkip && url) || (authData.isAuthenticated && url)) {
    const req = new XMLHttpRequest();
    req.open("GET", url, true);
    req.responseType = "blob";
    req.onload = function () {
      const blob = new Blob([req.response], {
        type: "application/pdf",
      });

      const isIE = false || !!document.documentMode;
      if (isIE) {
        window.navigator.msSaveBlob(blob, filename);
      } else {
        const windowUrl = window.URL || window.webkitURL;
        const href = windowUrl.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("download", filename);
        a.setAttribute("href", href);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    };
    req.send();
    // } else {
    //  history.push('/login');
    // }
  };

  const handleDownloads = (pdf_url) => {
    if (pdf_url) {
      forceDownload(pdf_url);
    } else {
      console.log("Url is Not Available");
    }
  };

  useEffect(() => {
    getListing();
  }, [route]);

  useEffect(() => {
    if (!loading && data && data.getCatalogueList) {
      if (route === "catalogue") {
        setSelectedCatalogue("Catalogue");
      } else {
        setSelectedCatalogue("Video");
      }
    }
  }, [loading, data]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(saveMegaMenu(false));
  }, []);

  return { data, loading, error, selectedCatalogue, handleDownloads };
};
